import TitleDuoTone from './TitleDuoTone';

export default TitleDuoTone;
